import { Outlet, useLocation } from '@remix-run/react'
import { useEffect } from 'react'
import { AppFooter, AppHeader } from '~/components'
import { useIsEmbed, useRouteMeta } from '~/hooks'
import { debounce } from '~/utils'
export { ErrorBoundary } from '~/components'

export const shouldRevalidate = () => false

function EmbedLayout() {
  useEffect(() => {
    const onResize = () => {
      parent.postMessage({ height: document.body.clientHeight }, '*')
    }
    onResize()
    const debouncedOnResize = debounce(onResize, 100)
    window.addEventListener('resize', debouncedOnResize)
  }, [])

  return <Outlet />
}

export default function AppLayout() {
  const location = useLocation()
  const isEmbed = useIsEmbed()
  const { setRouteMeta } = useRouteMeta()

  useEffect(() => {
    setRouteMeta({
      renderedMainMap: false,
    })
  }, [location.key])

  if (isEmbed) {
    return <EmbedLayout />
  }

  return (
    <>
      <AppHeader />
      <Outlet />
      <AppFooter />
    </>
  )
}
